
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog"
import { Button } from "@/components/ui/button"
import { useIsMobile } from "@/hooks/use-mobile"

interface RegistrationOptionsDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onOptionSelect: (option: 'express' | 'assisted') => void;
}

export function RegistrationOptionsDialog({
  open,
  onOpenChange,
  onOptionSelect,
}: RegistrationOptionsDialogProps) {
  const isMobile = useIsMobile();
  
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className={`sm:max-w-[480px] w-[95%] mx-auto p-4 sm:p-6 max-h-[90vh] overflow-y-auto ${isMobile ? 'top-[45%]' : ''}`}>
        <DialogHeader>
          <DialogTitle className="text-center text-lg sm:text-xl">
            Ótimo! Vamos começar o seu cadastro, como deseja continuar?
          </DialogTitle>
        </DialogHeader>
        <div className="flex flex-col gap-3 sm:gap-4 mt-4 sm:mt-6">
          <Button 
            onClick={() => onOptionSelect('express')}
            className="w-full text-left h-auto py-3 sm:py-4 flex flex-col items-start gap-1"
          >
            <span className="font-semibold">Cadastro expresso</span>
            <span className="text-xs sm:text-sm font-normal">
              Mais rápido e você faz sozinho
            </span>
          </Button>
          <Button 
            onClick={() => onOptionSelect('assisted')}
            variant="secondary"
            className="w-full text-left h-auto py-3 sm:py-4 flex flex-col items-start gap-1"
          >
            <span className="font-semibold">Cadastro assistido</span>
            <span className="text-xs sm:text-sm font-normal">
              Nosso consultor vai entrar em contato pra ajudar
            </span>
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  )
}
